import React, { useEffect, useCallback } from "react";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import TextField from "@mui/material/TextField";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";

const errorMessages = {
  rangeMinMax: "Please enter a minimum that is lower than the maximum",
  rangeFieldCompletion: "Please enter both a minimum and a maximum",
};

const RangeOption = (props) => {
  const { options, setOptions, errorDetected, noErrorDetected } = props;

  const range = options.range;
  if (!range.type) {
    if (range.min && range.max) {
      range.type = "custom";
    } else {
      range.type = "tag";
    }
  }

  const errorMessage = () => {
    let errorFound = false;
    for (let error in props.errors) {
      if (error.includes("range") && !errorFound) {
        errorFound = true;
        return (
          <p style={{ color: "red", fontSize: "10px" }}>
            {errorMessages[error]}
          </p>
        );
      }
    }
  };

  const validations = useCallback(
    (min, max) => {
      let currentMin = min != null ? Number(min) : Number(range.min);
      let currentMax = max != null ? Number(max) : Number(range.max);
      if (min === "") currentMin = null;
      if (max === "") currentMax = null;

      if (
        currentMin != null &&
        currentMax != null &&
        currentMin >= currentMax
      ) {
        errorDetected("rangeMinMax");
      } else {
        noErrorDetected("rangeMinMax");
      }
      if (currentMax == null) {
        errorDetected("rangeFieldCompletion");
      } else if (currentMin == null) {
        errorDetected("rangeFieldCompletion");
      } else {
        noErrorDetected("rangeFieldCompletion");
      }
    },
    [range.min, range.max, errorDetected, noErrorDetected]
  );

  useEffect(() => {
    if (range.type === "custom") {
      validations(range.min, range.max);
    }
  }, [validations, range.min, range.max, range.type]);

  return (
    <FormControl
      variant="standard"
      fullWidth={true}
      style={{
        flexDirection: "row",
        margin: 24,
        width: "calc(100% - 48px)",
      }}
    >
      <FormControl
        variant="standard"
        style={{ margin: 6, flexDirection: "column" }}
      >
        <FormLabel
          style={{ fontSize: 14, fontStyle: "italic", margin: 6 }}
          component="legend"
        >
          Range
        </FormLabel>
        <RadioGroup
          aria-label="rangetype"
          name="range"
          value={range.type}
          onChange={(event) => {
            const value = event.target.value;
            noErrorDetected("rangeFieldCompletion");
            noErrorDetected("rangeMinMax");
            setOptions({ range: { ...range, type: value } });
            //this.validations(null, null, event.target.value);
          }}
        >
          <FormControlLabel
            value="tag"
            control={<Radio />}
            label="Use Tag Settings"
          />
          <FormControlLabel value="custom" control={<Radio />} label="Custom" />
        </RadioGroup>
      </FormControl>
      {range.type === "custom" && (
        <FormControl
          variant="standard"
          style={{ margin: 6, flexDirection: "row" }}
        >
          <TextField
            variant="standard"
            sx={{
              marginLeft: 1,
              marginRight: 1,
              width: "50%",
            }}
            id="min-standard-number"
            label="Minimum"
            value={range.min || ""}
            onChange={(event) => {
              const val = event.target.value;
              setOptions({
                range: { ...range, min: val },
              });
            }}
            type="number"
            InputLabelProps={{ shrink: true }}
            margin="normal"
          />

          <TextField
            variant="standard"
            sx={{
              marginLeft: 1,
              marginRight: 1,
              width: "50%",
            }}
            id="max-standard-number"
            label="Maximum"
            value={range.max || ""}
            onChange={(event) => {
              const val = event.target.value;
              setOptions({
                range: { ...range, max: val },
              });
              validations(null, event.target.value);
            }}
            type="number"
            InputLabelProps={{ shrink: true }}
            margin="normal"
          />
        </FormControl>
      )}
      {range.type === "custom" && errorMessage()}
    </FormControl>
  );
};

export default RangeOption;
